import React from "react"

export const AddBucketIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.9">
        <path
          d="M21.0002 6.73C20.9802 6.73 20.9502 6.73 20.9202 6.73C15.6302 6.2 10.3502 6 5.12016 6.53L3.08016 6.73C2.66016 6.77 2.29016 6.47 2.25016 6.05C2.21016 5.63 2.51016 5.27 2.92016 5.23L4.96016 5.03C10.2802 4.49 15.6702 4.7 21.0702 5.23C21.4802 5.27 21.7802 5.64 21.7402 6.05C21.7102 6.44 21.3802 6.73 21.0002 6.73Z"
          fill="#292D32"
        />
        <path
          d="M8.49977 5.72C8.45977 5.72 8.41977 5.72 8.36977 5.71C7.96977 5.64 7.68977 5.25 7.75977 4.85L7.97977 3.54C8.13977 2.58 8.35977 1.25 10.6898 1.25H13.3098C15.6498 1.25 15.8698 2.63 16.0198 3.55L16.2398 4.85C16.3098 5.26 16.0298 5.65 15.6298 5.71C15.2198 5.78 14.8298 5.5 14.7698 5.1L14.5498 3.8C14.4098 2.93 14.3798 2.76 13.3198 2.76H10.6998C9.63977 2.76 9.61977 2.9 9.46977 3.79L9.23977 5.09C9.17977 5.46 8.85977 5.72 8.49977 5.72Z"
          fill="#292D32"
        />
        <path
          d="M15.2099 22.75H8.7899C5.2999 22.75 5.1599 20.82 5.0499 19.26L4.3999 9.19C4.3699 8.78 4.6899 8.42 5.0999 8.39C5.5199 8.37 5.8699 8.68 5.8999 9.09L6.5499 19.16C6.6599 20.68 6.6999 21.25 8.7899 21.25H15.2099C17.3099 21.25 17.3499 20.68 17.4499 19.16L18.0999 9.09C18.1299 8.68 18.4899 8.37 18.8999 8.39C19.3099 8.42 19.6299 8.77 19.5999 9.19L18.9499 19.26C18.8399 20.82 18.6999 22.75 15.2099 22.75Z"
          fill="#292D32"
        />
        <path
          d="M14.75 15H9.75C9.34 15 9 14.66 9 14.25C9 13.84 9.34 13.5 9.75 13.5H14.75C15.16 13.5 15.5 13.84 15.5 14.25C15.5 14.66 15.16 15 14.75 15Z"
          fill="#292D32"
        />
        <path
          d="M13 11.75L13 16.75C13 17.16 12.66 17.5 12.25 17.5C11.84 17.5 11.5 17.16 11.5 16.75L11.5 11.75C11.5 11.34 11.84 11 12.25 11C12.66 11 13 11.34 13 11.75Z"
          fill="#292D32"
        />
      </g>
    </svg>
  )
}
